import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CButton } from '@app/components/Common';
import { COLORS } from '@app/constants';
import { Text, View } from '@/styles/reactnative';
import { useWindowDimensions } from '@app/hooks';
import { HiddenEye } from '@app/components';
import { useTradeModalStore } from '@app/hooks/trade/modalStore';
import { ThemeContext } from '@/theme/ThemeProvider';
import { isMobile } from 'react-device-detect';
import { useIsMobile } from '@utils/CalVW.tsx';
import { useMyProfile } from '@app/hooks/user/myprofile';

const AssetSpotHeaderTop = () => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const btnData = [
    { title: 'deposit', key: 'deposit', goTo: '' },
    { title: t('withdrawList'), key: 'withdraw', goTo: '' },
    { title: 'transfer', key: 'transfer', goTo: '' },
  ];

  const { data: modalStore, mutate: muatateModalStore } = useTradeModalStore();
  const { data: myinfo } = useMyProfile();
  
  // KYC 인증 상태 확인 (level 1보다 크고 level 7이 아닌 경우 인증됨)
  const isKYCVerified = myinfo?.level && myinfo.level > 1 && myinfo.level !== 7;
  
  return (
    <View
      style={{
        flexDirection: 'row',
        width: '100%',
        height: '30%',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <View
        style={{
          alignItems: 'center',
          flexDirection: 'row',
        }}
      >
        <Text
          size={25}
          style={{
            marginRight: 10,
            fontWeight: '500',
          }}
        >
          {t('derivatives')}
        </Text>
        {/* <HiddenEye style={{ color: textw }} /> */}
      </View>
      {!isMobile && (
        <View
          style={{
            alignItems: 'center',
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginTop: 20,
          }}
        >
          {btnData?.map((item: any, index: any) => {
            // KYC 인증이 필요한 버튼들 (deposit, withdraw)
            const needsKYC = item.key === 'deposit' || item.key === 'withdraw';
            
            // KYC가 필요한 버튼이면서 인증되지 않은 경우 숨김
            if (needsKYC && !isKYCVerified) {
              return null;
            }
            
            return (
              <CButton
                key={index.toString()}
                title={t(item.title)}
                onClick={() => {
                  if (item?.key === 'transfer') {
                    muatateModalStore({
                      ...modalStore,
                      transferModal: true,
                      initialWallet: 'futurewallet'
                    });
                  } else if (item?.key === 'deposit') {
                    muatateModalStore({
                      ...modalStore,
                      depositModal: true,
                    });
                  } else if (item?.key === 'withdraw') {
                    muatateModalStore({
                      ...modalStore,
                      withdrawModal: true,
                    });
                  }
                }}
                border={{ width: '1px', color: COLORS.secondary }}
                style={{
                  justifyContent: 'center',
                  paddingBlock: 8,
                  paddingInline: 12,
                  marginRight: 10,
                  fontSize: 13,
                  background: COLORS.secondary,
                  color: COLORS.white,
                  fontWeight: 500,
                  cursor: "pointer"
                }}
              />
            );
          })}
        </View>
      )}
    </View>
  );
};

export default React.memo(AssetSpotHeaderTop);
